<template>
  <v-layout
    wrap
    justify-center>
    <v-flex
      xs12
      sm10
      md8
      lg8
      xl6>
      <v-container
        text-center
        fluid>
        <!-- 並び替えのボタングループ -->
        <v-row
          justify="center"
          align="center"
          class="my-3">
          <v-btn-toggle
            v-model="order"
            rounded
            class="text-center">
            <v-btn
              small
              value="new"
              class="px-10">
              新しい順
            </v-btn>
            <v-btn
              small
              value="old"
              class="px-8">
              懐かしい順
            </v-btn>
          </v-btn-toggle>
        </v-row>

        <v-scale-transition hide-on-leave>
          <MemoryCardsSkeleton
            v-if="isLoading"
            :isTwoLine="false" />

          <template v-else-if="memories.length !== 0">
            <v-container
              fluid
              class="pa-0">
              <v-layout wrap>
                <v-flex
                  v-for="memory in memories"
                  :key="memory.id"
                  xs6
                  md4>
                  <MemoryWithPrefectureCard :memory="memory" />
                </v-flex>
              </v-layout>
            </v-container>
          </template>

          <MemorySuggestionCard v-else />
        </v-scale-transition>

        <CreateFAB />
      </v-container>
    </v-flex>
  </v-layout>
</template>

<style scoped>
.py-20 {
  padding: 100px 0px;
}
.alert-color {
  color: grey;
}
</style>

<script>
import MemorySuggestionCard from '../components/Cards/MemorySuggestionCard';
import MemoryWithPrefectureCard from '../components/Cards/MemoryWithPrefectureCard';
import MemoryCardsSkeleton from '../components/SkeletonLoaders/MemolyCardsSkeleton';
import CreateFAB from '../components/FABs/CreateFAB';

import storeUtils from '../libs/storeUtils';
import ga from '../libs/ga';
import utils from '../libs/utils';

export default {
  components: {
    MemoryCardsSkeleton,
    MemorySuggestionCard,
    MemoryWithPrefectureCard,
    CreateFAB,
  },
  data() {
    return {
      memories: [],
      order: 'new',
      isLoading: true,
    };
  },
  watch: {
    '$store.state.reloadMemories': async function() {
      utils.consoleLog('[History] reload memories');

      this.isLoading = true;
      this.memories = [];
      await storeUtils.getAllData(this.$store, this.$ga);
      this.initMemories();
      this.isLoading = false;
    },
    order: function() {
      ga.memory.sortHistory(this.$ga);

      this.memories.sort((a, b) => {
        if (a.registeredDate < b.registeredDate) return this.order === 'new' ? 1 : -1;
        return this.order === 'new' ? -1 : 1;
      });
    },
  },
  created: async function() {
    this.$store.dispatch('initialLoginState', true);

    this.isLoading = true;

    // 思い出一覧やユーザデータの取得
    if (this.$store.state.memories.length === 0)
      await storeUtils.getAllData(this.$store, this.$ga);

    this.initMemories();
    this.isLoading = false;
  },
  methods: {
    initMemories: function() {
      for (let prefectures of this.$store.state.memories) {
        this.memories = this.memories.concat(prefectures);
      }

      // 全思い出を登録日順に並べる
      this.memories.sort((a, b) => {
        if (a.registeredDate < b.registeredDate) return 1;
        return -1;
      });
    },
  },
};
</script>
